import { STATES } from 'shared-constants'
import { type SelectOptionType } from 'components/Select'
import { type State } from 'types/graphql-generated'

export const STATE_OPTIONS: SelectOptionType<State>[] = STATES.map((state) => ({
  label: state.title,
  value: state,
}))

export const EMPTY_STATE_OPTION = {
  label: 'Select State',
  value: { shortCode: null, title: null },
}
